import superagent from 'superagent';
import {API_V2_URL} from "./base";

let _token;

function getAuthorizationHeader() {
  return `Token token=${_token}`;
}

export default class CreditCardsAPI {

  static SetUserAuthToken(token) {
    _token = token;
  }

  static GetCreditCards() {
    const URL = `${API_V2_URL}/payments/stripe/payment_methods`;

    return new Promise((resolve, reject) => {

      superagent.get(URL)
        .set('Accept', 'application/json')
        .set('Authorization', getAuthorizationHeader())
        .end((error, res) => {
          error ? resolve({ error: error.response?.body?.error || "" }) : resolve(res.body);
        });
    });
  }

  static CreateCreditCard(method) {
    const URL = `${API_V2_URL}/payments/stripe/payment_methods`;

    return new Promise((resolve, reject) => {

      superagent.post(URL)
        .set('Accept', 'application/json')
        .set('Authorization', getAuthorizationHeader())
        .send({payment_method_id: method.id})
        .end((error, res) => {
          error ? reject(error) : resolve(res.body);
        });
    });
  }

  static DeleteCreditCard(method) {
    const URL = `${API_V2_URL}/payments/stripe/payment_methods/${method.id}`;

    return new Promise((resolve, reject) => {

      superagent
        .del(URL)
        .set('Accept', 'application/json')
        .set('Authorization', getAuthorizationHeader())
        .send({source: method.id})
        .end((error, res) => {
          error ? reject(error) : resolve(res.body);
        });
    });
  }
}
